// extracted by mini-css-extract-plugin
module.exports = {"historical-report-table":"historical-report-table"};